import LocomotiveScroll from 'locomotive-scroll';

let options = {
    el: document.querySelector('#js-scroll'),
    getSpeed: true,
    getDirection: true,
    useKeyboard: true,
};

if(options.el !== null) {
    if (options.el.getAttribute('data-horizontal') === 'true') {
        options.direction = 'horizontal';
        options.tablet = {
            smooth: true,
            direction: 'horizontal',
            horizontalGesture: true
        };
        options.smartphone = {
            smooth: false
        };
        options.reloadOnContextChange = true;
    }
}

export let scroll = new LocomotiveScroll(options);

export function locomotive () {
    scroll.on('scroll', function (instance) {
        let progress = 360 * instance.scroll.y / instance.limit.y;
    });

    scroll.on('call', function (value, way, obj) {
        // Do something
    });
}

export function updateScroll() {
    scroll.update();
}

export function initScroll() {
    scroll.init();
}